import { render, staticRenderFns } from "./SaisieFactureInstructeur.vue?vue&type=template&id=b812e990"
import script from "./SaisieFactureInstructeur.vue?vue&type=script&lang=js"
export * from "./SaisieFactureInstructeur.vue?vue&type=script&lang=js"
import style0 from "./SaisieFactureInstructeur.vue?vue&type=style&index=0&id=b812e990&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports